// import global from "@/prototype/global.js";
// const log = global.log.getLogger("f_mtac.storage.space.context");

const Style = function() {
    const style = window.document.createElement("style");
    style.type = "text/css";
    window.document.head.appendChild(style);
    const rules_top = {}, rules = {};
    let apply = () => {
        let styles = "";
        for(let rule_name in rules_top) {
            styles += rules_top[rule_name];
        }
        for(let rule_name in rules) {
            styles += rules[rule_name];
        }
        style.innerHTML = styles;
    };

    this.rule_set_top = (name, rule) => {
        rules_top[name] = rule;
        apply();
    };

    this.rule_unset_top = (name) => {
        delete rules_top[name];
        apply();
    };

    this.rule_set = (name, rule) => {
        rules[name] = rule;
        apply();
    };

    this.rule_unset = (name) => {
        delete rules[name];
        apply();
    };

    this.rule_unset_all = () => {
        for (let rule_name in rules) {
            delete rules[rule_name];
        }
    };
};

export default Style;
